import {Trans} from '@lingui/macro';
import {ellipsis} from 'polished';
import React, {FC} from 'react';
import styled from 'styled-components';

import {
  DropdownItem,
  DropdownItemProps,
} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownItem';
import {DropdownItemContent} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownItemContent';
import {Icon} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface AddSchedulingLinkDropdownItemProps extends DropdownItemProps {}

/*
 * Style.
 */

const StyledContentDiv = styled.div`
  display: grid;
  grid-template-areas: 'add-icon title';
  grid-template-columns: auto auto;
`;

const StyledAddIconDiv = styled.div`
  grid-area: add-icon;
  margin-right: 8px;
  margin-top: auto;
  margin-bottom: auto;
  height: 20px;
  background-color: ${(p) => p.theme.palette.blue.shade20};
  border-radius: 100px;
`;

const StyledTitleDiv = styled.div`
  grid-area: title;
  color: ${(p) => p.theme.greys.shade80};
  font-size: ${fontSizes.medium};
  font-weight: ${fontWeights.medium};
  ${ellipsis()};
`;

/*
 * Component.
 */

export const AddSchedulingLinkDropdownItem: FC<AddSchedulingLinkDropdownItemProps> = (props) => {
  const theme = useUserTheme();

  return (
    <DropdownItem {...props}>
      <DropdownItemContent>
        <StyledContentDiv>
          <StyledAddIconDiv>
            <Icon name="dropdownNew" color={theme.palette.blue.shade40} />
          </StyledAddIconDiv>
          <StyledTitleDiv>
            <Trans id="dropdown-schedulinglinks-new">New scheduling link</Trans>
          </StyledTitleDiv>
        </StyledContentDiv>
      </DropdownItemContent>
    </DropdownItem>
  );
};
